// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52dad9bb","239":"5bcfbab5","455":"f346e178","821":"d572855e"}[chunkId] + ".chunk.js";
};